import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import RegionPage from "./pages/RegionPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProjectsPage from "./pages/ProjectsPage";
import HallPlannerPage from "./pages/HallPlannerPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import LegalPage from "./pages/LegalPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminTranslations from "./pages/admin/AdminTranslations";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminServices from "./pages/admin/AdminServices";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminTeam from "./pages/admin/AdminTeam";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminPartners from "./pages/admin/AdminPartners";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPlanner from "./pages/admin/AdminPlanner";
import AdminSEO from "./pages/admin/AdminSEO";

const PUBLIC_ROUTES = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/leistungen", element: <ServicesPage /> },
  { path: "/leistungen/:slug", element: <ServiceDetailPage /> },
  { path: "/projects", element: <ProjectsPage /> },
  { path: "/planner", element: <HallPlannerPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/impressum", element: <LegalPage type="impressum" /> },
  { path: "/datenschutz", element: <LegalPage type="datenschutz" /> },
];
const LANG_PREFIXES = ["", "/en", "/es"];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          {LANG_PREFIXES.flatMap(prefix => PUBLIC_ROUTES.map(({ path, element }) => (
            <Route key={prefix + path} path={prefix + (path === "/" ? "" : path) || "/"} element={<PublicLayout>{element}</PublicLayout>} />
          )))}
          <Route path="/einsatzgebiete/:slug" element={<PublicLayout><RegionPage /></PublicLayout>} />
          {LANG_PREFIXES.map(prefix => (
            <Route key={`${prefix}-services`} path={`${prefix}/services`} element={<Navigate to={`${prefix}/leistungen`} replace />} />
          ))}
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="faq" element={<AdminFAQ />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="planner" element={<AdminPlanner />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="translations" element={<AdminTranslations />} />
            <Route path="contacts" element={<AdminContacts />} />
          </Route>
          <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
